<!-- <small>
  Copyright hint: the PDF file has been published by
  <a href="https://de.linkedin.com/in/stephan-rauh-a6a398aa">Stephan Rauh</a> on
  <a href="https://www.beyondjava.net/page/beyondjava-conference"
    >BeyondJava.net</a
  >
  under a
  <a
    target="#"
    rel="license"
    href="https://creativecommons.org/licenses/by-nc-nd/3.0/de/"
    >Creative Commons Attribution-NonCommercial-NoDerivs 3.0 Germany License.<br
  /></a>
</small> -->
<div class="h-full w-full flex flex-col">
  <div class="flex items-center justify-end p-2 border-b" *ngIf="pdfSrc">
    <button mat-icon-button (click)="downloadPdf()" [disabled]="downloading" matTooltip="Download PDF">
      <mat-spinner *ngIf="downloading" diameter="20"></mat-spinner>
      <mat-icon *ngIf="!downloading">download</mat-icon>
    </button>
  </div>
  <div class="flex-1 overflow-auto">
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [original-size]="false"
      [show-all]="showAll"
      [page]="pageVariable"
      [zoom]="zoom"
      [rotation]="rotation"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [fit-to-page]="true"
      [render-text-mode]="2"
      (page-rendered)="onPageRendered($event)"
      (error)="onPdfLoadingFailed($event)"
      style="display: block; height: 100%; width: 100%;">
    </pdf-viewer>
  </div>
</div>
